import { FileUpload } from "../file-upload.model";

export type ImageFile = {
  id : string | undefined,
  url : string;
}

export function fileUploadToImageFile(file: FileUpload): ImageFile {
  return {
    id: file.id,
    url: file.url
  } as ImageFile;
}
